import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { TNKCurrencyMaskDirective } from './currency-mask/currency-mask.directive';

import { TNKCurrencyPipe } from './currency/currency.pipe';
import { LimitArrayPipe } from './limit-array/limit-array.pipe';
import { OffsetArrayPipe } from './offset-array/offset-array.pipe';
export class TNKUtilitiesModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  declarations: [TNKCurrencyPipe, LimitArrayPipe, OffsetArrayPipe],
  exports: [TNKCurrencyPipe, LimitArrayPipe, OffsetArrayPipe],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function TNKUtilitiesModule_tsickle_Closure_declarations() {
/** @type {?} */
TNKUtilitiesModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TNKUtilitiesModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
